import script from "./CurrentAid.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentAid.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentAid.vue?vue&type=style&index=0&id=67565a28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67565a28"]])

export default __exports__